import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import { Desert } from '../images/illustrations/no-data';

import './NoAttributes.scss';
import { Button } from '@salesforce/design-system-react';

class NoAttributes extends Component {
  render() {
    const { attributeType } = this.props;
    const { formatMessage } = this.props.intl;
    const helpLinks = {
      asset:
        'https://help.salesforce.com/articleView?id=mc_pb_add_an_asset_attribute.htm&type=5',
      profile:
        'https://help.salesforce.com/articleView?id=mc_pb_manage_profile_attributes.htm&type=5'
    };
    const helpLink = helpLinks[attributeType];

    const getStarted = (
      <Button
        label={formatMessage({
          id: 'components.ecs.attributes.noData.getStarted'
        })}
        variant="brand"
        onClick={() => this.props.onGetStarted()}
      />
    );

    return (
      <div className="attribute-no-data">
        <div className="illustration-and-text">
          <Desert />
          <div className="slds-text-longform">
            <h1 className="slds-text-heading_medium">
              <FormattedMessage
                id={`components.ecs.attributes.noData.${attributeType}.header`}
              />
            </h1>
            <p>
              <FormattedMessage
                id={`components.ecs.attributes.noData.${attributeType}.description`}
                values={{
                  link: (
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      href={helpLink}
                    >
                      {formatMessage({
                        id: 'components.ecs.attributes.noData.helpLinkText'
                      })}
                    </a>
                  )
                }}
              />
            </p>
          </div>
          {this.props.showGetStarted ? getStarted : null}
        </div>
      </div>
    );
  }
}

NoAttributes.propTypes = {
  intl: intlShape.isRequired,
  showGetStarted: PropTypes.bool,
  onGetStarted: PropTypes.func,
  attributeType: PropTypes.oneOf(['asset', 'profile']).isRequired
};

export default injectIntl(NoAttributes);
